import { buildRumConfig } from '@pac/cloudwatch-rum';

export default buildRumConfig({
    stages: {
        prd: {
            applicationId: '8aed2796-7a11-4667-88eb-db9138a8795f',
            identityPoolId: 'us-west-2:68a710d8-3068-4fbb-b147-af24c30e2a8d',
            guestRoleArn: '',
        },
        test: {
            applicationId: '0fd8ac4f-930f-48b2-81e3-d607a899088e',
            identityPoolId: 'us-west-2:b24d69a8-ea6d-44ac-a2f3-7862de54d31a',
            guestRoleArn: '',
        },
        dev: {
            applicationId: '2ca946e4-6df2-4367-9524-eb0a4c83a453',
            identityPoolId: 'us-west-2:1760251d-ab6e-48d0-9a8f-388aac6bcf88',
            guestRoleArn: '',
        },
        ide: {
            applicationId: '2ca946e4-6df2-4367-9524-eb0a4c83a453',
            identityPoolId: 'us-west-2:1760251d-ab6e-48d0-9a8f-388aac6bcf88',
            guestRoleArn: '',
        },
    },
});
